module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Set Password","action":{"set":"Set password"},"problem":{"401_2":"{message} The link in your email may have expired, and a new email may have to be sent."},"alert":{"success":"The password was reset successfully."}}}')
  delete Component.options._Ctor
}
